import axiosClient from "../requests/axiosCLient";
import { API_URLS } from "../../constants/constants";

export const getDealersDetails = (page) => {
  const url = API_URLS.dealersDetails(page);
  return axiosClient.get(url);
};
export const getPreDealersDetails = () => {
  const url = API_URLS.preDealersDetails;
  return axiosClient.get(url);
};
